/**
 * Attachments of one type from the unified attachment list (`attachments` of a project or block).
 * @param {Array<Object>|null|undefined} attachments
 * @param {string} attachmentType
 * @returns {Array<Object>} the attachments of the type, in stored order; empty without attachments
 */
export const attachmentsOfType = (attachments, attachmentType) =>
  (attachments ?? []).filter((attachment) => attachment.attachmentType === attachmentType);
